import { FieldValues } from 'react-hook-form';

import {
  FormAwareTypeaheadMultiSelectInput,
  FormAwareTypeaheadMultiSelectInputProps,
} from '@/components/form/formAwareInputs/FormAwareTypeaheadMultiSelectInput';

import { useClientsTypeahead } from './hooks/useClientsTypeahead';

export type ClientsTypeaheadProps<FormShape extends FieldValues> = Omit<
  FormAwareTypeaheadMultiSelectInputProps<FormShape>,
  'options' | 'inputValue' | 'onInputChange'
>;

export function ClientsTypeahead<FormShape extends FieldValues>(
  props: ClientsTypeaheadProps<FormShape>
) {
  const { typeaheadProps } = useClientsTypeahead<FormShape>(props.fieldName);

  return (
    <FormAwareTypeaheadMultiSelectInput<FormShape>
      {...typeaheadProps} // supplied by useAsyncTypeaheadProps
      {...props} // label, fieldName, disabled, etc.
      placeholder="Select client(s)"
    />
  );
}
